import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ResultItemContext } from '../../../types';

const ProductResultItemTemplate = (context: ResultItemContext) => (
  <result-item
    type={context.product.type}
    class={context.hidden ? 'hidden' : ''}
    href={context.product.links.pip}
    key={context.key}
    onClick={() => context.ref.onSelectItem(context.product, context.position, context.queryID, context.listType)}
    tabindex="0"
  >
    <result-item-image>
      <img src={context.product.images.small} />
    </result-item-image>
    <result-item-details>
      {context.product.category !== '' ? (
        <result-item-label
          link={context.product.links.category}
          onClick={(event: MouseEvent) =>
            context.ref.onCategoryClick(event, context.product, context.position, context.listType)
          }
        >
          {context.product.category}
        </result-item-label>
      ) : (
        <result-item-label></result-item-label>
      )}
      <result-item-headline>{context.product.name}</result-item-headline>
      <result-item-descr>{context.product.description}</result-item-descr>
      <result-item-price>
        {context.product.price
          ? [
              <span>{context.product.price.formatted}</span>,
              <abbr title={''}>*</abbr>,
              <small>{context.product.price.specification}</small>,
            ]
          : ''}
      </result-item-price>
    </result-item-details>
  </result-item>
);

export default ProductResultItemTemplate;
